import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../../interfaces/auth";
import { getDepartmentThunk } from "../../../../asyncThunks/manage/setups";

const initialState: defaultState = {
    error: null,
    data: [],
    loading: false,
};

export const getDepartment = createSlice({
    name: "getDepartment",
    initialState,
    reducers: {
        updateDepartmentData: (state, action) => {
            const updatedDepartment = action.payload;
            if (state.data) {
                const index = state.data?.departments?.findIndex((departments: { _id: any; }) => departments._id === updatedDepartment._id);
                if (index !== -1) {
                    state.data.departments[index] = updatedDepartment;
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDepartmentThunk.pending, (state, action) => {
            state.error = null;
            // state.data = null;
            state.loading = true;
        });
        builder.addCase(getDepartmentThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action?.payload?.data;
            } else {
                state.error = action?.payload;
                state.data = [];
            }
            state.loading = false;
        });
        builder.addCase(getDepartmentThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = [];
            state.loading = false;
        });
    },
});

export const { updateDepartmentData } = getDepartment.actions;

export default getDepartment.reducer;
